import React, { useRef } from 'react';
import { Row, Col } from 'react-bootstrap';
import Form from 'react-bootstrap/Form';
import 'bootstrap/dist/css/bootstrap.min.css';
import Head from '../../components/navbar/Head.js';
import NavBar from '../../components/navbar/NavBar.js';
import Card from 'react-bootstrap/Card';
import { useState, useEffect } from 'react';
import Button from 'react-bootstrap/Button';
import TagsInput from 'react-tagsinput'
import 'react-tagsinput/react-tagsinput.css'
import { isNumeric } from 'validator';
import { getPublisher, uploadPdfEbook, uploadFileEbook, updateEbookCoverPath, updateEbookPDFPath, insertEbookDetails, getEbookPrice, getEbookCategory, getPublisherTag, getPublisherKeyword, getEbookSerie, uploadEpubEbook, uploadEpubSampleEbook, updateEbookEpubFileStatus, updateEbookEpubSampleFileStatus } from '../../api'
import { useNavigate } from 'react-router-dom';
import Spinner from 'react-bootstrap/Spinner';
import { Alert } from 'react-bootstrap';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { useDispatch } from 'react-redux';
import { dialogConfirmSetData, dialogConfirmSetShowModal } from '../../actions/confirmDialog.action.js';
import {  setCurrentManageBookPage} from '../../actions/site.action.js'; 

const AddBooks = () => {
    const dispatch = useDispatch();
    dispatch(setCurrentManageBookPage(1))
    const [selectedDate, handleDateChange] = React.useState(new Date());
    const [checkButtonLoading, setCheckButtonLoading] = useState('1');
    const [showAlertError, setShowAlertError] = useState(false);
    const [showUploadImageErrorMessage, setUploadImageErrorMessage] = useState('');
    const [showUploadPdfErrorMessage, setUploadPdfErrorMessage] = useState('');
    const [uploadEBook, setUploadEBook] = useState('');
    const [uploadEBookName, setUploadEBookName] = useState('');
    const [selectedFileCoverImage, setSelectedFileEbook] = useState(null);
    const [tags, setTags] = useState([]);
    const [Keywords, setKeywords] = useState([]);
    const [selectedPdf, setSelectedPdf] = useState(null);
    const [selectedPdfName, setSelectedPdfName] = useState(null);
    const [selectedEpub, setSelectedEpub] = useState(null);
    const [selectedEpubName, setSelectedEpubName] = useState(null);
    const [selectedSampleEpub, setSelectedSampleEpub] = useState(null);
    const [selectedSampleEpubName, setSelectedSampleEpubName] = useState(null);
    const [CoverPriceError, setCoverPriceError] = useState('');
    const [selectedOnlyOver, setOnlyOver] = useState('');
    const [PricingAndSales, setPricingAndSales] = useState('');
    const [publishOption, setPublishOption] = useState('as_review_pass');
    //Get ราคา EbookPrice
    const [optionsgetEbookPrice, setOptionsgetEbookPrice] = useState([]);
    //getEbookCategory
    const [optionsgetEbookCategory, setOptionsgetEbookCategory] = useState([]);
    //getPublisherKeyword
    const [getPublisherKeywords, setgetPublisherKeyword] = useState([]);
    //getPublisherTag
    const [getPublisherTags, setgetPublisherTag] = useState([]);
    const [otherSeries, setOtherSeries] = useState('0');
    //getEbookSerie
    const [getEbookSeries, setgetEbookSerie] = useState([]);
    const [formData, setFormData] = useState('');
    const [validated, setValidated] = useState(false);

    const uploadImageRef = useRef();
    const uploadPDFRef = useRef();
    const uploadEpubRef = useRef();
    const uploadSampleEpubRef = useRef();

    const handleTagsChange = (tags) => {
        setTags(tags);
    };

    const customPlaceholder = 'Add a keywords';

    const handleKeywords = (tags) => {
        setKeywords(tags);
    };

    const [rightToLeft, setRightToLeft] = useState('0');

    const handleChangeRightToLeft = () => {
         const newValue = rightToLeft === '1' ? '0' : '1';
        setRightToLeft(newValue);

    }

    const handleImageChange = (event) => {
        const acceptedTypes = ["image/jpeg", "image/jpg"];
        const file = event.target.files[0];

        if (!acceptedTypes.includes(file.type)) {
            // alert("ไฟล์รูปภาพต้องเป็น .jpg, .jpeg, หรือ .png เท่านั้น");
            dispatch(dialogConfirmSetData({
                title: "Error",
                message: "Supported file extensions .jpg .jpeg only",
                closeButton: "",
                confirmButton: "OK",
                eventConfirmButton: () => null,
                eventCloseButton: () => null,
                showCloseButton: false
            }));
            // ** ทำให้ dialog โชว์ขึ้นมา **
            dispatch(dialogConfirmSetShowModal(true));
            // เคลียร์ input
            uploadImageRef.current.value = null;
            return;
        }

        setSelectedFileEbook(file);
        setUploadEBook(URL.createObjectURL(file));
        setUploadEBookName(file.name);
    };

    const handlePdfChange = (event) => {
        if(event.target.files.length === 0) {
            setSelectedPdfName(null);
            return;
        }
        const file = event.target.files[0];
        const fileType = file.type;
        const fileName = file.name.toLowerCase();
        
        // Accept PDF, EPUB, and INDD files
        const acceptedTypes = [
            "application/pdf"
        ];
        
        const acceptedExtensions = [".pdf"];
        const hasValidExtension = acceptedExtensions.some(ext => fileName.endsWith(ext));

        if (!acceptedTypes.includes(fileType) && !hasValidExtension) {
            dispatch(dialogConfirmSetData({
                title: "Error",
                message: "Supported file extensions: .pdf only",
                closeButton: "",
                confirmButton: "OK",
                eventConfirmButton: () => null,
                eventCloseButton: () => null,
                showCloseButton: false
            }));
            // ** ทำให้ dialog โชว์ขึ้นมา **
            dispatch(dialogConfirmSetShowModal(true));
            // เคลียร์ input
            uploadPDFRef.current.value = null;
          return;
        }
        setSelectedPdfName(file);
    };

    const handleEpubChange = (event) => {
        if(event.target.files.length === 0) {
            setSelectedEpubName(null);
            return;
        }
        const file = event.target.files[0];
        const fileType = file.type;
        const fileName = file.name.toLowerCase();
        
        // Accept PDF, EPUB, and INDD files
        const acceptedTypes = [
            "application/epub+zip",
            // "application/x-indesign"
        ];
        
        const acceptedExtensions = [".epub"];
        const hasValidExtension = acceptedExtensions.some(ext => fileName.endsWith(ext));

        if (!acceptedTypes.includes(fileType) && !hasValidExtension) {
            dispatch(dialogConfirmSetData({
                title: "Error",
                message: "Supported file extensions: .epub",
                closeButton: "",
                confirmButton: "OK",
                eventConfirmButton: () => null,
                eventCloseButton: () => null,
                showCloseButton: false
            }));
            // ** ทำให้ dialog โชว์ขึ้นมา **
            dispatch(dialogConfirmSetShowModal(true));
            // เคลียร์ input
            uploadEpubRef.current.value = null;
          return;
        }
        setSelectedEpubName(file);
    };

    const handleSampleEpubChange = (event) => {
        if(event.target.files.length === 0) {
            setSelectedSampleEpubName(null);
            return;
        }
        const file = event.target.files[0];
        const fileType = file.type;
        const fileName = file.name.toLowerCase();
        
        // Accept PDF, EPUB, and INDD files
        const acceptedTypes = [
            "application/epub+zip",
            // "application/x-indesign"
        ];
        
        const acceptedExtensions = [".epub"];
        const hasValidExtension = acceptedExtensions.some(ext => fileName.endsWith(ext));

        if (!acceptedTypes.includes(fileType) && !hasValidExtension) {
            dispatch(dialogConfirmSetData({
                title: "Error",
                message: "Supported file extensions: .epub",
                closeButton: "",
                confirmButton: "OK",
                eventConfirmButton: () => null,
                eventCloseButton: () => null,
                showCloseButton: false
            }));
            // ** ทำให้ dialog โชว์ขึ้นมา **
            dispatch(dialogConfirmSetShowModal(true));
            // เคลียร์ input
            uploadSampleEpubRef.current.value = null;
          return;
        }
        setSelectedSampleEpubName(file);
    };

    const handleChange = (event) => {
        const { name, value } = event.target || '';

        if(name === 'paperCoverPrice' && parseInt(value) < 0) {
           return;
        } else {
            setFormData((prevData) => ({ ...prevData, [name]: value }));
        }

        if (name === 'paperCoverPrice') {
            if (!isNumeric(value) && value != '' && value != null) {
                setCoverPriceError('Please enter numbers only.');
            }
        }
    }

    const handleChangeOnlyOver = () => {
        const newValue = selectedOnlyOver === '1' ? '0' : '1';
        setOnlyOver(newValue);
    };
    
    const [typeReader, setTypeReader] = useState('both');
    const handleReader = (event) => {
        setTypeReader(event.target.value);

    };

    const handlePricingAndSales = (event) => {
        setPricingAndSales(event.target.value);
    };

    const handleStatus = (event) => {
        setPublishOption(event.target.value);
        // console.log(event.target.value);
    };

    function showEbookPrice() {
        getEbookPrice().then(handleShowEbookPrice)
    }
    const handleShowEbookPrice = async (response) => {
        setOptionsgetEbookPrice(response.data);
    }

    function showEbookCategory() {
        getEbookCategory().then(handleShowEbookCategory)
    }
    const handleShowEbookCategory = async (response) => {
        setOptionsgetEbookCategory(response.data);
    }

    function showGetPublisherKeyword() {
        getPublisherKeyword().then(handleshowGetPublisherKeyword)
    }
    const handleshowGetPublisherKeyword = async (response) => {
        setgetPublisherKeyword(response.data);
    }

    function showGetPublisherTag() {
        getPublisherTag().then(handleshowGetPublisherTag)
    }
    const handleshowGetPublisherTag = async (response) => {
        setgetPublisherTag(response.data);
    }

    const setKeywordsItem = (keyword) => {
        if (!Keywords.includes(keyword)) {
            setKeywords((prevKeywords) => [...prevKeywords, keyword]);
        }
    };

    const setTagsItem = (Tags) => {
        if (!tags.includes(Tags)) {
            setTags((prevKeywords) => [...prevKeywords, Tags]);
        }
    };

    const handleChangeOtherSeries = (event) => {
        setOtherSeries(event.target.value);
    }

    function showgetEbookSerie() {
        getEbookSerie().then(handleshowgetEbookSerie)
    }
    const handleshowgetEbookSerie = async (response) => {
        setgetEbookSerie(response.data);
    }

    useEffect(() => {
        setPublishOption('as_review_pass');
        setPricingAndSales('for_sale');
        showEbookPrice();
        showEbookCategory();
        setOnlyOver('0');
        showGetPublisherTag();
        showGetPublisherKeyword();
        setOtherSeries('0');
        showgetEbookSerie();
    }, []);

    const handleSubmit = async (event) => {
        event.preventDefault();

        // File upload validation
        const hasPdf = selectedPdfName !== null;
        const hasEpub = selectedEpubName !== null;
        const hasSampleEpub = selectedSampleEpubName !== null;

        // Validation Rule 1: At least one file type (PDF or EPUB) must be selected
        if (!hasPdf && !hasEpub) {
            dispatch(dialogConfirmSetData({
                title: "Validation Error",
                message: "Please select at least one file type: PDF or EPUB.",
                closeButton: "",
                confirmButton: "OK",
                eventConfirmButton: () => null,
                eventCloseButton: () => null,
                showCloseButton: false
            }));
            dispatch(dialogConfirmSetShowModal(true));
            return;
        }

        // Validation Rule 3: If EPUB sample is selected, EPUB is required
        if (hasSampleEpub && !hasEpub) {
            dispatch(dialogConfirmSetData({
                title: "Validation Error",
                message: "EPUB file is required when EPUB sample file is selected.",
                closeButton: "",
                confirmButton: "OK",
                eventConfirmButton: () => null,
                eventCloseButton: () => null,
                showCloseButton: false
            }));
            dispatch(dialogConfirmSetShowModal(true));
            return;
        }

        //#####Upload E-Book Cover
        //uploadEBookName
        const bookTitle = formData.bookTitle || "";
        const authorName = formData.authorName || "";
        const category = formData.cateGory || "";
        //otherSeries
        const otherSeriesName = formData.otherSeriesName || "";
        const volume = formData.volume || "";

        //selectedOnlyOver
        const synopsis = formData.synopsis || "";
        const bookType = formData.bookType || "";
        const isbn = formData.isbn || "";
        const isbnEbook = formData.isbnEbook || "";
        //tags
        //Keywords

        //####Pricing and Sales
        //PricingAndSales
        const paperCoverPrice = formData.paperCoverPrice || '0';
        const paperBookPrice = formData.paperBookPrice || '9';
        //selectedPdfName

        //####Status
        //const publicDate = formData.publicDate || '';

        // const timestamp = selectedDate || null;
        // const date = new Date(timestamp);
        // const publicDate = `${date.getFullYear()}/${(date.getMonth() + 1).toString().padStart(2, '0')}/${date.getDate().toString().padStart(2, '0')} ${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}`;

        let publicDate = null;
        const timestamp = selectedDate || null;
        if(publishOption === 'schedule'){
            const date = new Date(timestamp);
            publicDate = `${date.getFullYear()}/${(date.getMonth() + 1).toString().padStart(2, '0')}/${date.getDate().toString().padStart(2, '0')} ${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}`; 
        }
        const noteTeam = formData.noteTeam || "";
        const form = event.currentTarget;

        const _getPublisher = async () => {
            try {
                const response = await getPublisher();
                // console.log('xxxx' + response.data['result']['publisherID']);
                return response.data['result']['publisherID'];
            } catch (error) {
                // console.error("Error while getting publisher:", error);
                // Handle the error or return a default value
                return '';
            }
        };

        if (form.checkValidity() === true) {
            setCheckButtonLoading('2');
            event.preventDefault();
            event.stopPropagation();
            
            let publisherId = "";

            let getPublisherResult = await _getPublisher();
            publisherId = getPublisherResult;

            insertEbookDetails(uploadEBookName, bookTitle, authorName, category, otherSeries, otherSeriesName, selectedOnlyOver, synopsis, bookType, isbn, isbnEbook, tags, Keywords,
                PricingAndSales, paperCoverPrice, paperBookPrice,
                publishOption, publicDate, noteTeam, volume , rightToLeft , typeReader)
            .then((response) => handleAfterInsertEbook(response, publisherId));
        }

        setValidated(true);
    }

    async function handleAfterInsertEbook(response, publisherId) {
        let ebookDetailsID = response.data;
        let uploadResult = await uploadBookResource(publisherId, ebookDetailsID);

        // Check for multiple upload errors
        const hasImageError = uploadResult['isUploadImageError'] === true;
        const hasPdfError = uploadResult['isUploadPdfError'] === true;
        const hasEpubError = uploadResult['isUploadEpubError'] === true;
        const hasEpubSampleError = uploadResult['isUploadEpubSampleError'] === true;

        // Build error message for multiple errors
        let errorMessages = [];
        if (hasImageError) errorMessages.push(uploadResult['uploadImageErrorMessage']);
        if (hasPdfError) errorMessages.push(uploadResult['uploadPdfErrorMessage']);
        if (hasEpubError) errorMessages.push(uploadResult['uploadEpubErrorMessage']);
        if (hasEpubSampleError) errorMessages.push(uploadResult['uploadEpubSampleErrorMessage']);

        if (errorMessages.length > 0) {
            setCheckButtonLoading('1');
            
            // Reset all file states on error
            if (hasImageError) setUploadEBook('');
            if (hasPdfError) setSelectedPdf(null);
            if (hasEpubError) setSelectedEpub(null);
            if (hasEpubSampleError) setSelectedSampleEpub(null);

            dispatch(dialogConfirmSetData({
                title: "Error",
                message: errorMessages.join('\n\n'),
                closeButton: "",
                confirmButton: "OK",
                eventConfirmButton: () => null,
                eventCloseButton: () => null,
                showCloseButton: false
            }));
            dispatch(dialogConfirmSetShowModal(true));
        } else {
            goToViewEbookPage(ebookDetailsID);
        }
    }

    function goToViewEbookPage(ebookId){
        navigate('/ViewEbooks', {
            replace: true,
            state: {
                ebookDetailsID: ebookId,
                bookTitle: formData.bookTitle
            }
        });
    }

    async function uploadBookResource(publisherId, ebookDetailsID) {

        var uploadCoverImagePath = null;
        var uploadSamplePdfPath = null;
        var uploadMainPdfPath = null;

        var isUploadCoverError = false;
        var uploadCoverErrorMessage = "";

        var isUploadPdfError = false;
        var uploadPdfErrorMessage = "";

        var isUploadEpubError = false;
        var uploadEpubErrorMessage = "";

        var isUploadEpubSampleError = false;
        var uploadEpubSampleErrorMessage = "";

        // Upload cover image if selected
        if (selectedFileCoverImage !== null) {
            const uploadFilePromise = uploadFileEbook(selectedFileCoverImage, ebookDetailsID, publisherId)
                .then(async response => {
                    if (response.data['access_path'] != null && response.data['error'] !== true) {
                        uploadCoverImagePath = response.data['access_path'];
                        await updateEbookCoverPath(uploadCoverImagePath, ebookDetailsID);
                    } else {
                        isUploadCoverError = true;
                        uploadCoverErrorMessage = "We're sorry, but it looks like there's an issue with the file you uploaded. Please ensure you're uploading a valid file with the correct format";
                    }
                });

            await Promise.all([uploadFilePromise]);
        }

        // Upload PDF if selected
        if (selectedPdfName !== null) {
            const uploadPdfPromise = uploadPdfEbook(selectedPdfName, ebookDetailsID, publisherId)
                .then(async response => {
                    if (response.data['error'] === false) {
                        uploadSamplePdfPath = "uploaded";
                        uploadMainPdfPath = "uploaded";
                        await updateEbookPDFPath(uploadMainPdfPath, uploadSamplePdfPath, ebookDetailsID);
                    } else {
                        isUploadPdfError = true;
                        uploadPdfErrorMessage = "We're sorry, but it looks like there's an issue with the file you uploaded. Please ensure you're uploading a valid file with the correct format";
                    }
                });

            await Promise.all([uploadPdfPromise]);
        }

        // Upload EPUB if selected
        if (selectedEpubName !== null) {
            const uploadEpubPromise = uploadEpubEbook(selectedEpubName, ebookDetailsID, publisherId)
                .then(async response => {
                    var uploadStatus = true;
                    if (response.data['error'] === false) {
                        uploadStatus = true;
                    } else {
                        uploadStatus = false;
                        isUploadEpubError = true;
                        uploadEpubErrorMessage = "We're sorry, but it looks like there's an issue with the file you uploaded. Please ensure you're uploading a valid file with the correct format";
                    }
                    await updateEbookEpubFileStatus(uploadStatus, ebookDetailsID);
                });

            await Promise.all([uploadEpubPromise]);
        }

        // Upload sample EPUB if selected
        if (selectedSampleEpubName !== null) {
            const uploadEpubSamplePromise = uploadEpubSampleEbook(selectedSampleEpubName, ebookDetailsID, publisherId)
                .then(async response => {
                    var uploadStatus = true;
                    if (response.data['error'] === false) {
                        uploadStatus = true;
                    } else {
                        uploadStatus = false;
                        isUploadEpubSampleError = true;
                        uploadEpubSampleErrorMessage = "We're sorry, but it looks like there's an issue with the file you uploaded. Please ensure you're uploading a valid file with the correct format";
                    }
                    await updateEbookEpubSampleFileStatus(uploadStatus, ebookDetailsID);
                });

            await Promise.all([uploadEpubSamplePromise]);
        }

        if (isUploadPdfError || isUploadCoverError || isUploadEpubError || isUploadEpubSampleError) {
            let result = {
                "isUploadPdfError": isUploadPdfError,
                "isUploadImageError": isUploadCoverError,
                "isUploadEpubError": isUploadEpubError,
                "isUploadEpubSampleError": isUploadEpubSampleError,
                "uploadPdfErrorMessage": uploadPdfErrorMessage,
                "uploadImageErrorMessage": uploadCoverErrorMessage,
                "uploadEpubErrorMessage": uploadEpubErrorMessage,
                "uploadEpubSampleErrorMessage": uploadEpubSampleErrorMessage
            };

            return result;
        } else {
            let result = {
                "isUploadPdfError": false,
                "isUploadImageError": false,
                "isUploadEpubError": false,
                "isUploadEpubSampleError": false
            };

            return result;
        }
    }


    const navigate = useNavigate();
    const handleCancel = () => {
        navigate('/ManageBooks');
        // console.log('dsdsadsads');
    };

    const handleBackClick = () => {
        navigate('/ManageBooks', { replace: true });
    };

    // const handleClickPdf = () => {
    //     window.open(selectedPdf, '_blank');
    // };

    const deleteFilePdf = () => {
        dispatch(dialogConfirmSetData({
            title: "Confirm clear",
            message: "This will remove the selected file from the upload.",
            closeButton: "Cancel",
            confirmButton: "Remove",
            eventConfirmButton: () => {
                setSelectedPdf(null);
                setSelectedPdfName(null);
            },
            eventCloseButton: () => null,
            showCloseButton: true
        }));
        // ** ทำให้ dialog โชว์ขึ้นมา **
        dispatch(dialogConfirmSetShowModal(true));
    }

    const deleteFileEpub = () => {
        dispatch(dialogConfirmSetData({
            title: "Confirm clear",
            message: "This will remove the selected file from the upload.",
            closeButton: "Cancel",
            confirmButton: "Remove",
            eventConfirmButton: () => {
                setSelectedEpub(null);
                setSelectedEpubName(null);
            },
            eventCloseButton: () => null,
            showCloseButton: true
        }));
        // ** ทำให้ dialog โชว์ขึ้นมา **
        dispatch(dialogConfirmSetShowModal(true));
    }

    const deleteFileSampleEpub = () => {
        dispatch(dialogConfirmSetData({
            title: "Confirm clear",
            message: "This will remove the selected file from the upload.",
            closeButton: "Cancel",
            confirmButton: "Remove",
            eventConfirmButton: () => {
                setSelectedSampleEpub(null);
                setSelectedSampleEpubName(null);
            },
            eventCloseButton: () => null,
            showCloseButton: true
        }));
        // ** ทำให้ dialog โชว์ขึ้นมา **
        dispatch(dialogConfirmSetShowModal(true));
    }


    const deleteProFileCover = () => {
        dispatch(dialogConfirmSetData({
            title: "Confirm clear",
            message: "This will remove the selected file from the upload.",
            closeButton: "Cancel",
            confirmButton: "Remove",
            eventConfirmButton: () => {
                setUploadEBook("");
                setSelectedFileEbook(null);
                setUploadEBookName("");
            },
            eventCloseButton: () => null,
            showCloseButton: true
        }));
        // ** ทำให้ dialog โชว์ขึ้นมา **
        dispatch(dialogConfirmSetShowModal(true));
    }

    return (
        <div >
            <Head />
            <Row className='row-navbar'>
                <NavBar />
                <Col className='row-context' >
                    <main>

                        <div className='box-context'>
                            <span className='title-text'> <div className='title-content-text' onClick={() => handleBackClick()}>Manage Books</div> <div style={{marginLeft: '10px',marginRight: '10px'}}>{'›'}</div>Add E-Books</span>
                            <p className='context-text'>Add your new E-Book.</p>

                            <Card className='card-box card-box-top-pading'>
                                <Card.Body>
                                    <div className='content-box'>
                                        <span className='inner-title-text'>Book Details</span>
                                        <hr className='hr-title' />
                                        <Form noValidate validated={validated} onSubmit={handleSubmit}>


                                            <Form.Group as={Row} className="mb-12" controlId="">
                                                <Form.Label column sm="4">
                                                    <div style={{ paddingBottom: '0px' }}>
                                                        <span className='my-rowlabel'>Upload E-Book Cover<span className='star' >*</span> </span>
                                                    </div>
                                                </Form.Label>
                                                <Col sm="6" style={{ paddingTop: '10px' }}>
                                                    {(uploadEBook) ?
                                                        <>
                                                            <div className="image-frame" >
                                                                <img src={uploadEBook} alt="Selected" style={{ maxHeight: '250px' }} />
                                                            </div>
                                                            <div>
                                                                <span className='text-alerts' ></span>
                                                            </div>
                                                            <a onClick={() => deleteProFileCover()}
                                                                className='delete-link link-button'>
                                                                Delete
                                                            </a>
                                                        </>
                                                        :
                                                        <div>
                                                            <Form.Control ref={uploadImageRef} required type="file" accept="image/jpeg" value={formData.uploadEBook} name="uploadEBook" onChange={handleImageChange} />
                                                            <div>
                                                                <span className='text-alerts' >Supported file extensions .jpg .jpeg only</span>
                                                            </div>
                                                        </div>
                                                    }

                                                </Col>
                                            </Form.Group>
                                            <br></br>


                                            <Form.Group as={Row} className="mb-3" controlId="">
                                                <Form.Label column sm="4">
                                                    Book Title <span className='star' >*</span>
                                                </Form.Label>
                                                <Col sm="6">
                                                    <Form.Control required type="text" maxLength={200} value={formData.bookTitle} name="bookTitle" onChange={handleChange} />
                                                </Col>
                                            </Form.Group>

                                            <Form.Group as={Row} className="mb-3" controlId="">
                                                <Form.Label column sm="4">
                                                    Author Name <span className='star' >*</span>
                                                </Form.Label>
                                                <Col sm="6">
                                                    <Form.Control required type="text" maxLength={255} value={formData.authorName} name="authorName" onChange={handleChange} />
                                                </Col>
                                            </Form.Group>

                                            <Form.Group as={Row} className="mb-3" controlId="">
                                                <Form.Label column sm="4">
                                                    Category <span className='star' >*</span>
                                                </Form.Label>
                                                <Col sm="6">
                                                    <Form.Select required value={formData.cateGory} name="cateGory" onChange={handleChange} >
                                                        <option value=''>Please Select</option>
                                                        {optionsgetEbookCategory.map((option) => (
                                                            <option key={option.id} value={option.id}>
                                                                {option.name_th}
                                                            </option>
                                                        ))}
                                                    </Form.Select>
                                                </Col>
                                            </Form.Group>


                                            <Form.Group as={Row} className="mb-3" controlId="">
                                                <Form.Label column sm="4">Book Series<span className='star' >*</span></Form.Label>
                                                <Col sm="6">
                                                    <Form.Select required value={otherSeries} name="otherSeries" onChange={handleChangeOtherSeries}>
                                                        <option value='0' >Other Series</option>
                                                        {getEbookSeries.map((option) => (
                                                            <option key={option.serie_id} value={option.serie_id}>
                                                                {option.serie_name}
                                                            </option>
                                                        ))}
                                                    </Form.Select>

                                                </Col>
                                            </Form.Group>


                                            {otherSeries === '0' && (
                                                <div>
                                                    <Form.Group as={Row} className="mb-3" controlId="">
                                                        <Form.Label column sm="4">
                                                        </Form.Label>
                                                        <Col sm="6">
                                                            <Form.Control required aria-label="New Book series" maxLength={100} placeholder="New Book series" type="text" value={formData.otherSeriesName} name="otherSeriesName" onChange={handleChange} />
                                                        </Col>
                                                    </Form.Group>
                                                </div>
                                            )}

                                            <Form.Group as={Row} className="mb-3" controlId="">
                                                <Form.Label column sm="4">
                                                </Form.Label>
                                                <Col sm="6">
                                                    <Form.Control required aria-label="Order of books in this series" placeholder="Order of books in this series" type="number" min={1} name="volume" onChange={handleChange} />
                                                    <span className='text-alerts' >Order of books in this series</span>
                                                </Col>

                                            </Form.Group>

                                            <Form.Group as={Row} className="mb-3" controlId="">
                                                <Form.Label column sm="4">
                                                    Only for People Over 18 Years Old
                                                </Form.Label>
                                                <Col sm="6">
                                                    <Form.Check
                                                        label="Yes"
                                                        type='checkbox'
                                                        name='onlyOver'
                                                        value='1'
                                                        onChange={handleChangeOnlyOver}
                                                        inline
                                                        checked={selectedOnlyOver === '1'}
                                                    />
                                                </Col>
                                            </Form.Group>

                                            <Form.Group as={Row} className="mb-3" controlId="">
                                                <Form.Label column sm="4">
                                                    Synopsis
                                                </Form.Label>
                                                <Col sm="6">
                                                    <Form.Control
                                                        value={formData.synopsis}
                                                        name="synopsis"
                                                        maxLength={1000}
                                                        onChange={handleChange}
                                                        as="textarea"
                                                        placeholder=""
                                                        style={{ height: '100px' }}
                                                    />
                                                </Col>
                                            </Form.Group>

                                            <Form.Group as={Row} className="mb-3" controlId="">
                                                <Form.Label column sm="4">Book Type<span className='star' >*</span>
                                                </Form.Label>
                                                <Col sm="6">
                                                    <Form.Select required value={formData.bookType} name="bookType" onChange={handleChange} >
                                                        <option value=''>Please Select</option>
                                                        <option value="1" >Thai Book</option>
                                                        <option value="2" >Translated Book</option>
                                                    </Form.Select>
                                                </Col>
                                            </Form.Group>

                                            <Form.Group as={Row} className="mb-3" controlId="">
                                                <Form.Label column sm="4">
                                                    ISBN
                                                </Form.Label>
                                                <Col sm="6">
                                                    <Form.Control type="text" maxLength={30} value={formData.isbn} name="isbn" onChange={handleChange} />
                                                </Col>
                                            </Form.Group>

                                            <Form.Group as={Row} className="mb-3" controlId="">
                                                <Form.Label column sm="4">
                                                    ISBN E-Book
                                                </Form.Label>
                                                <Col sm="6">
                                                    <Form.Control type="text" maxLength={30} value={formData.isbnEbook} name="isbnEbook" onChange={handleChange} />
                                                </Col>
                                            </Form.Group>

                                            <Form.Group as={Row} className="mb-3" controlId="">
                                                <Form.Label column sm="4">
                                                                Right-to-left reading style
                                                </Form.Label>
                                                <Col sm="6">

                                                    <Form.Check
                                                        type='checkbox'
                                                        name='rightToLeft'
                                                        value='1'
                                                        onChange={handleChangeRightToLeft}
                                                        inline
                                                        checked={rightToLeft === '1'}
                                                    />
                                    
                                                </Col>
                                            </Form.Group>

                                            <Form.Group as={Row} className="mb-3" controlId="">
                                                <Form.Label column sm="4">
                                                  Reading Direction 
                                                </Form.Label>
                                                <Col sm="6">
                                                <Form.Check
                                                        label="Horizontal and Vertical Scrolling"
                                                        type='radio'
                                                        name='reader'
                                                        value='both'
                                                        onChange={handleReader}
                                                        inline
                                                        checked={typeReader === 'both'}
                                                    />

                                                    <Form.Check
                                                        label="Vertical Scrolling only"
                                                        type='radio'
                                                        name='reader'
                                                        value='vertical'
                                                        onChange={handleReader}
                                                        inline
                                                        checked={typeReader === 'vertical'}
                                                    />

                                                </Col>
                                            </Form.Group>

                                            <Form.Group as={Row} className="mb-3" controlId="">
                                                <Form.Label column sm="4" >
                                                    Tags
                                                </Form.Label>
                                                <Col sm="6" style={{ border: '1px solid #ced4da', borderRadius: '6px', marginLeft: '10px', width: '48.5%', paddingTop: '10px' }}>
                                                    <TagsInput className='input-tag-custom' required value={tags} onChange={handleTagsChange} addOnBlur={true} addOnPaste={true} onlyUnique={true} />

                                                </Col>
                                            </Form.Group>

                                            <Form.Group as={Row} className="mb-3" controlId="">
                                                <Form.Label column sm="4">
                                                </Form.Label>
                                                <Col sm="6">
                                                    <div style={{ display: 'flex', gap: '5px', flexWrap: 'wrap' }} className='div-my-button'>
                                                        {getPublisherTags.map((option) => (
                                                            (!tags.includes(option.tag_name)) ?
                                                                <a key={option.tag_name} style={{ marginRight: '2px', color: '#fff' }} onClick={() => setTagsItem(option.tag_name)} className="my-button"> <span className='font-tags'>{option.tag_name} +</span></a>
                                                                : <></>
                                                        ))}
                                                    </div>
                                                </Col>
                                            </Form.Group>

                                            <Form.Group as={Row} className="mb-3" controlId="">
                                                <Form.Label column sm="4">
                                                    Keywords
                                                </Form.Label>
                                                <Col sm="6" style={{ border: '1px solid #ced4da', borderRadius: '6px', marginLeft: '10px', width: '48.5%', paddingTop: '10px' }}>
                                                    <TagsInput className='input-keyword-custom' required value={Keywords} onChange={handleKeywords} placeholder={customPlaceholder} addOnBlur={true} addOnPaste={true} onlyUnique={true} inputProps={{ placeholder: customPlaceholder }} />

                                                </Col>
                                            </Form.Group>

                                            <Form.Group as={Row} className="mb-3" controlId="">
                                                <Form.Label column sm="4">
                                                </Form.Label>
                                                <Col sm="6">
                                                    <div style={{ display: 'flex', gap: '5px', flexWrap: 'wrap' }} className='div-my-button'>
                                                        {getPublisherKeywords.map((option) => (
                                                            (!Keywords.includes(option.keyword_name)) ?
                                                                <a key={option.keyword_name} style={{ marginRight: '2px', color: '#fff' }} onClick={() => setKeywordsItem(option.keyword_name)} className="my-button-keyboard"> <span className='font-tags'>{option.keyword_name} + </span></a>
                                                                : <></>
                                                        ))}
                                                    </div>
                                                </Col>
                                            </Form.Group>

                                            <br></br>
                                            <span className='inner-title-text'>Pricing and Sales</span>
                                            <hr className='hr-title' />
                                            <Form.Group as={Row} className="mb-3" controlId="">
                                                <Form.Label column sm="4">
                                                    Type Sales <span className='star' >*</span>
                                                </Form.Label>
                                                <Col sm="6">
                                                    <Form.Check
                                                        label="Books for Sale"
                                                        type='radio'
                                                        name='PricingAndSales'
                                                        value='for_sale'
                                                        onChange={handlePricingAndSales}
                                                        inline
                                                        checked={PricingAndSales === 'for_sale'}

                                                    />

                                                    <Form.Check
                                                        label="Free Books"
                                                        type='radio'
                                                        name='PricingAndSales'
                                                        value='free'
                                                        onChange={handlePricingAndSales}
                                                        inline
                                                        checked={PricingAndSales === 'free'}

                                                    />
                                                </Col>
                                            </Form.Group>
                                            {PricingAndSales === 'for_sale' && (
                                                <div>
                                                    <Form.Group as={Row} className="mb-3" controlId="">
                                                        <Form.Label column sm="4">
                                                            Paper Cover Price  <span className='star' >*</span>
                                                        </Form.Label>
                                                        <Col sm="6">
                                                            <Form.Control required type="text" onKeyPress={(event) => { if (!/[0-9]/.test(event.key)) { event.preventDefault() } }}  min="0"  isInvalid={!!CoverPriceError} value={formData.paperCoverPrice} name="paperCoverPrice" onChange={handleChange}>
                                                            </Form.Control>
                                                            <Form.Control.Feedback type="invalid">
                                                                {CoverPriceError}
                                                            </Form.Control.Feedback>
                                                        </Col>
                                                    </Form.Group>

                                                    <Form.Group as={Row} className="mb-3" controlId="">
                                                        <Form.Label column sm="4">
                                                            Book Price  <span className='star' >*</span>
                                                        </Form.Label>
                                                        <Col sm="6">
                                                            <Form.Select 
                                                                required={PricingAndSales === 'for_sale'}
                                                                 value={formData.paperBookPrice} name="paperBookPrice" onChange={handleChange}>
                                                                <option value=''>Please Select</option>
                                                                {optionsgetEbookPrice.map((option) => (
                                                                    <option key={option.id} value={option.id}>
                                                                        {option.price}
                                                                    </option>
                                                                ))}
                                                            </Form.Select>
                                                        </Col>
                                                    </Form.Group>

                                                </div>
                                            )}
                                            <br></br>
                                            <span className='inner-title-text'>E-Book File</span>
                                            <span className='text-alerts' >Upload at least one E-Book File Type</span>
                                            <hr className='hr-title' />

                                            <Form.Group as={Row} className="mb-3" controlId="">

                                                <Form.Label column sm="4">
                                                    <div style={{ paddingBottom: '60px' }} >
                                                        <span className='my-rowlabel'>Upload E-Book File</span>
                                                    </div>
                                                </Form.Label>
                                                <Col sm="6">
                                                    {(selectedPdf) ?
                                                        <div >
                                                             <Form.Label column sm="4">
                                                               There is a file uploaded
                                                                 </Form.Label>
                                                            <a onClick={() => deleteFilePdf()} className='delete-link link-button'>Delete</a>
                                                        </div>
                                                        :
                                                        <div>
                                                            <div className="d-flex">
                                                                <Form.Control ref={uploadPDFRef} type="file" accept=".pdf" onChange={handlePdfChange} />
                                                            </div>
                                                            <div>
                                                                <span className='text-alerts' >Supported file extension .pdf only</span>
                                                            </div>
                                                        </div>
                                                    }
                                                </Col>
                                            </Form.Group>

                                            <Form.Group as={Row} className="mb-3" controlId="">

                                                <Form.Label column sm="4">
                                                    <div style={{ paddingBottom: '60px' }} >
                                                        <span className='my-rowlabel'>Upload Epub File</span>
                                                    </div>
                                                </Form.Label>
                                                <Col sm="6">
                                                    {(selectedEpub) ?
                                                        <div >
                                                             <Form.Label column sm="4">
                                                               There is a file uploaded
                                                                 </Form.Label>
                                                            <a onClick={() => deleteFileEpub()} className='delete-link link-button'>Delete</a>
                                                        </div>
                                                        :
                                                        <div>
                                                            <Form.Control ref={uploadEpubRef} type="file" accept=".epub" onChange={handleEpubChange} />
                                                            <div>
                                                                <span className='text-alerts' >Supported file extensions: .epub</span>
                                                            </div>
                                                        </div>
                                                    }
                                                </Col>
                                            </Form.Group>

                                            <Form.Group as={Row} className="mb-3" controlId="">

                                                <Form.Label column sm="4">
                                                    <div style={{ paddingBottom: '60px' }} >
                                                        <span className='my-rowlabel'>Upload Sample Epub File</span>
                                                    </div>
                                                </Form.Label>
                                                <Col sm="6">
                                                    {(selectedSampleEpub) ?
                                                        <div >
                                                             <Form.Label column sm="4">
                                                               There is a file uploaded
                                                                 </Form.Label>
                                                            <a onClick={() => deleteFileSampleEpub()} className='delete-link link-button'>Delete</a>
                                                        </div>
                                                        :
                                                        <div>
                                                            <Form.Control ref={uploadSampleEpubRef} type="file" accept=".epub" onChange={handleSampleEpubChange} />
                                                            <div>
                                                                <span className='text-alerts' >Supported file extensions: .epub</span>
                                                            </div>
                                                        </div>
                                                    }
                                                </Col>
                                            </Form.Group>

                                            <br></br>
                                            <span className='inner-title-text'>On-sale date</span>
                                            <hr className='hr-title' />
                                            <Form.Group as={Row} className="mb-12" controlId="">
                                                <Form.Label column sm="4">
                                                    <span className='my-rowlabel'>Status<span className='star' >*</span></span>
                                                </Form.Label>
                                                <Col >
                                                    <Form.Check
                                                        label="As soon as review pass"
                                                        type='radio'
                                                        name='publishOption'
                                                        value='as_review_pass'
                                                        checked={publishOption === 'as_review_pass'}
                                                        onChange={handleStatus}
                                                        inline

                                                    />

                                                    <Form.Check
                                                        label="Scheduled"
                                                        type='radio'
                                                        name='publishOption'
                                                        value='schedule'
                                                        checked={publishOption === 'schedule'}
                                                        onChange={handleStatus}
                                                        inline

                                                    />
                                                </Col>
                                            </Form.Group>

                                            <div style={{ paddingTop: '10px' }}></div>

                                            {publishOption === 'schedule' && (
                                                <div>
                                                    <Form.Group as={Row} className="mb-3" controlId="">
                                                        <Form.Label column sm="4">
                                                            Publish Date <span className='star' >*</span>
                                                        </Form.Label>
                                                        <Col sm="6" className='date-time-input'>
                                                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                                <DemoContainer components={['DateTimePicker']}>
                                                                    <DateTimePicker
                                                                        label=""
                                                                        isBeforeDay={true}
                                                                        onChange={handleDateChange}
                                                                        format="DD/MM/YYYY HH:mm"
                                                                        ampm={false}
                                                                        defaultValue={dayjs(selectedDate)} />
                                                                </DemoContainer>
                                                            </LocalizationProvider>
                                                        </Col>
                                                    </Form.Group>
                                                </div>
                                            )}

                                            <Form.Group as={Row} className="mb-3" controlId="">
                                                <Form.Label column sm="4">
                                                Note to Reviewers
                                                </Form.Label>
                                                <Col sm="6">
                                                    <Form.Control as="textarea" rows="8" maxLength={200} value={formData.noteTeam} name="noteTeam" onChange={handleChange} />

                                                </Col>
                                            </Form.Group>

                                            <br></br>

                                            <center>

                                                <div>
                                                    {showAlertError && (
                                                        <Alert variant="danger" onClose={() => setShowAlertError(false)} dismissible>
                                                            <Alert.Heading>Error</Alert.Heading>
                                                            <p>
                                                                {showUploadImageErrorMessage + showUploadPdfErrorMessage}
                                                            </p>
                                                        </Alert>
                                                    )}
                                                </div>

                                                {checkButtonLoading === '1' && (
                                                    <Button className='button-form-cancel button-main button-white' onClick={handleCancel} variant="primary" >Cancel</Button>
                                                )}

                                                {checkButtonLoading === '1' && (
                                                    <Button className='button-form-save button-main button-orange' variant="primary" type="submit">Save</Button>
                                                )}

                                                {checkButtonLoading === '2' && (
                                                    <Spinner animation="border" role="status">
                                                        <span className="visually-hidden">Loading...</span>
                                                    </Spinner>
                                                )}

                                            </center>
                                        </Form>
                                    </div>
                                </Card.Body>
                            </Card>
                        </div>
                    </main>
                </Col>
            </Row>
        </div >
    );
};

export default AddBooks;
